import { ActionLogPersonalDetailsPayload } from '@/shared/services/actionLog/ActionLogPersonalDetailsPayload';
import { ActionLogQuestionnairePayload } from '@/shared/services/actionLog/ActionLogQuestionnairePayload';

export enum ActionLogAction {
  editPersonalDetails = 'editPersonalDetails',
  editQuestionnaire = 'editQuestionnaire',
  questionnaireCompleted = 'questionnaireCompleted',
  consentSigned = 'consentSigned',
  loggedIn = 'loggedIn',
}

export class ActionLog {
  action: ActionLogAction;

  payload?: ActionLogQuestionnairePayload | ActionLogPersonalDetailsPayload[];
}
